import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Store } from '@ngrx/store';

import {
  AuthRedirectService, AuthRedirectStorageService, AuthService, AuthStorageService, RoutingService, StateWithClientAuth, UserIdService
} from '@spartacus/core';

import { CustomOAuthLibWrapperService } from './custom-o-auth-lib-wrapper.service';

@Injectable({
  providedIn: 'root'
})
export class CustomAuthService extends AuthService {
  private toggleLoginSubject = new Subject<void>();

  constructor(
    protected store: Store<StateWithClientAuth>,
    protected userIdService: UserIdService,
    protected oAuthLibWrapperService: CustomOAuthLibWrapperService,
    protected authStorageService: AuthStorageService,
    protected authRedirectService: AuthRedirectService,
    protected authRedirectStorageService: AuthRedirectStorageService,
    protected routingService: RoutingService
  ) {
    super(store, userIdService, oAuthLibWrapperService, authStorageService, authRedirectService, routingService);
  }

  async getLoginUrl(): Promise<string> {
    return this.oAuthLibWrapperService.getLoginUrl();
  }

  public get toggleLogin$(): Observable<void> {
    return this.toggleLoginSubject.asObservable();
  }

  public toggleLoginWithRedirect(redirectUrl?: string, setDefault = true): void {
    if (!!redirectUrl || setDefault) {
      this.authRedirectStorageService.setRedirectUrl(redirectUrl || '/my-account-dashboard');
    }
    this.toggleLoginSubject.next();
  }
}
